import React,{useState } from "react";
import { Col, Button } from "react-bootstrap";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { FaMobileAlt, FaGlobe } from "react-icons/fa";
import { IoHardwareChipOutline } from "react-icons/io5";



function ProjectCard({ project, index }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Col md={4} className="project-card">
      <div 
        className="modern-project-card"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
        }}
      >
        {/* Image Container */}
        <div className="project-image-container">
          <img 
            src={project.imgPath} 
            alt={project.title}
            className={`project-image ${isHovered ? 'hovered' : ''}`}
          />
          <div className={`image-overlay ${isHovered ? 'hovered' : ''}`} />
          
          {/* Type Badge */}
          <div className="project-type-badge">
            {project.type === 'mobile' ? <FaMobileAlt /> : project.type === 'web' ? <FaGlobe /> : project.type === 'hardware' ? <IoHardwareChipOutline /> : <FaGlobe />}
            <span>{project.type === 'mobile' ? 'Mobile' : project.type === 'web' ? 'Web' : project.type === 'hardware' ? 'Hardware' : 'Other'}</span>
          </div>
        </div>

        {/* Content */}
        <div className="project-content">
          <h3 className="project-title">{project.title}</h3>
          
          {/* Tags */}
          <div className="project-tags">
            {project.tags.map((tag, i) => (
              <span key={i} className="project-tag">{tag}</span>
            ))}
          </div>

          {/* Description */}
          <p className="project-description">{project.description}</p>

          {/* Stats */}
          {project.stats && (
            <div className="project-stats">
              {project.stats.map((stat, i) => (
                <div key={i} className="stat-item">
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          )}

          {/* Buttons */}
          <div className="project-buttons">
            <Button 
              variant="primary" 
              href={project.ghLink} 
              target="_blank"
              className="project-btn github-btn"
            >
              <BsGithub /> &nbsp; Code
            </Button>
            {project.demoLink && (
              <Button
                variant="primary"
                href={project.demoLink}
                target="_blank"
                className="project-btn demo-btn"
              >
                <CgWebsite /> &nbsp; Live Demo
              </Button>
            )}
          </div>
        </div>
      </div>
    </Col>
  );
}
export default ProjectCard;
